import Konva from "konva";

/**
 * This method is called to zoom where the pointer is in the project open in the creationController given in parameter.
 * @param {CreationController} creationController
 * @param {Event} event
 */
export function zoomWheelEvent(creationController, event) {
  const scaleBy = 0.9;
  const oldScale = creationController.scale;
  const mousePointTo = {
    x: creationController.stage.getPointerPosition().x / oldScale - creationController.stage.x() / oldScale,
    y: creationController.stage.getPointerPosition().y / oldScale - creationController.stage.y() / oldScale,
  };
  const newScale = event.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;
  if (newScale < 0.25 || newScale > 6) {
    return;
  }

  creationController.scale = newScale;
  creationController.stage.scale({ x: newScale, y: newScale });

  const newPos = {
    x: -(mousePointTo.x - creationController.stage.getPointerPosition().x / newScale) * newScale,
    y: -(mousePointTo.y - creationController.stage.getPointerPosition().y / newScale) * newScale,
  };

  creationController.stage.x(newPos.x);
  creationController.stage.y(newPos.y);
}

export function displayTransformerOnClick(creationController, event) {
  // Click on stage or widget move locked
  if (event.target === creationController.stage) {
    // Remove all transformer visible and deselect current
    creationController.destroyAllTransformer();
    creationController.deselectCurrentElement();
    return;
  }
  // ??!
  if (event.target.parent instanceof Konva.Transformer) {
    return;
  }

  if (!event.target.attrs.draggable) {
    // In case its scrolling or rss object
    if (event.target.hasName("rectScrolling") || event.target.hasName("textScrolling")) {
      event.target = event.target.parent;
    } else if (event.target.hasName("iconWeather") || event.target.hasName("textWeather")) {
      if (event.target.parent.attrs.draggable) {
        event.target = event.target.parent;
      }
    } else {
      // Remove all transformer visible and deselect current
      creationController.destroyAllTransformer();
      creationController.deselectCurrentElement();
      return;
    }
  }
  // Remove all transformer visible and deselect current
  creationController.destroyAllTransformer();
  creationController.deselectCurrentElement();

  // Create and draw new Transformer of corresponding item
  creationController.currentElement = creationController.getElementFromName(event.target.id());
  const transformer = createTransformer(creationController);
  creationController.currentSelection = transformer;
  event.target.parent.add(transformer);
  transformer.nodes([event.target]);

  try {
    creationController.stage.draw();
  } catch (err) {
    console.error(err);
  }
}

function createTransformer(creationController) {
  // Check movable to authorize resize
  let isMovable = false;
  if (creationController.currentElement && creationController.currentElement.konvaObjectOption !== undefined) {
    if (creationController.currentElement.konvaObjectOption.movable !== undefined) {
      if (creationController.currentElement.konvaObjectOption.movable) {
        isMovable = true;
      }
    } else {
      isMovable = true;
    }
  } else {
    isMovable = true;
  }

  if (isMovable) {
    if (creationController.currentElement && creationController.currentElement.name.includes("Scrolling")) {
      return new Konva.Transformer({
        resizeEnabled: false,
        rotateEnabled: false,
        keepRatio: false,
        enabledAnchors: [
          "top-left",
          "top-center",
          "top-right",
          "middle-right",
          "middle-left",
          "bottom-center",
          "bottom-left",
          "bottom-right",
        ],
        rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],
      });
    } else {
      return new Konva.Transformer({
        keepRatio: false,
        enabledAnchors: [
          "top-left",
          "top-center",
          "top-right",
          "middle-right",
          "middle-left",
          "bottom-center",
          "bottom-left",
          "bottom-right",
        ],
        rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],
      });
    }
  } else {
    return new Konva.Transformer({
      keepRatio: false,
      enabledAnchors: [],
      resizeEnabled: false,
      rotateEnabled: false,
    });
  }
}

/**
 * This method is use to move the stage with the middle click only. (Creates a warning if the mouse is outside the stage, still a bit buggy)
 * @param {CreationController} creationController
 * @param {Event} event
 */
export function moveStage(creationController, event) {
  event.evt.preventDefault();
  if (creationController.startingMovePos == null) {
    creationController.startingMovePos = {};
    creationController.startingMovePos.stage = {
      x: creationController.stage.x(),
      y: creationController.stage.y(),
    };
    creationController.startingMovePos.cursor = {
      x: creationController.stage.getPointerPosition().x,
      y: creationController.stage.getPointerPosition().y,
    };
  }
  if (event.target.attrs.draggable) {
    creationController.elementPreventMoving = event.target;
    creationController.elementPreventMovingLastPos = {
      x: event.target.attrs.x,
      y: event.target.attrs.y,
    };
  }
  //This task is made every 0.030s until the interval is clear in the moveStageEnd() function.
  if (!creationController.repetitiveTask) {
    creationController.repetitiveTask = setInterval(() => {
      try {
        creationController.stage.x(
          creationController.startingMovePos.stage.x -
            (creationController.startingMovePos.cursor.x - creationController.stage.getPointerPosition().x)
        );
        creationController.stage.y(
          creationController.startingMovePos.stage.y -
            (creationController.startingMovePos.cursor.y - creationController.stage.getPointerPosition().y)
        );
      } catch (err) {
        moveStageEnd(creationController, event);
        return;
      }
    }, 30);
  }
}

/**
 * This method must be called when the stage has been moved.
 * @param {CreationController} creationController
 * @param {Event} event
 */
export function moveStageEnd(creationController, event) {
  clearInterval(creationController.repetitiveTask);

  if (creationController.elementPreventMoving != null) {
    replacePreventMovingObjectInPlace(creationController);
  }

  creationController.repetitiveTask = false;
  creationController.startingMovePos = null;
  event.evt.preventDefault();
  return;
}

function replacePreventMovingObjectInPlace(creationController) {
  creationController.elementPreventMoving.setAttr("x", creationController.elementPreventMovingLastPos.x);
  creationController.elementPreventMoving.setAttr("y", creationController.elementPreventMovingLastPos.y);
  creationController.elementPreventMoving = null;
  creationController.elementPreventMovingLastPos = null;
}

export function moveStageHorizontally(creationController, event) {
  event.evt.preventDefault();
  let moveBy = 20; //GO RIGHT

  if (event.evt.deltaY > 0) {
    //GO LEFT
    moveBy = -20;
  }

  creationController.stage.x(creationController.stage.x() + moveBy);
}

export function moveStageVertically(creationController, event) {
  event.evt.preventDefault();
  let moveBy = 20; //GO UP

  if (event.evt.deltaY > 0) {
    //GO DOWN
    moveBy = -20;
  }

  creationController.stage.y(creationController.stage.y() + moveBy);
}
